<template>
  <LutticaScrollBar :scrollingX="false" v-if="height" :height="height" ref="dropMenuBar">
    <ul class="ivu-dropdown-menu"><slot></slot></ul>
  </LutticaScrollBar>
  <ul v-else class="ivu-dropdown-menu"><slot></slot></ul>
</template>
<script>
    export default {
        name: 'DropdownMenu',
        props: {
            height: {
              type: [String, Boolean],
              default: false,
            }
        },
        methods: {
            scrollToAim(position) {
              if (this.$refs.dropMenuBar) {
                this.$refs.dropMenuBar.scrollTo({ y: position });
              }
            }
        }
    };
</script>
